import { IconProps } from './IconProps';

export const CartDecrease = ({
  className,
  style,
  fill = 'black',
  width = 10,
  height = 2,
}: {
  className?: string;
  style?: Record<string, unknown>;
  fill?: string;
  width?: number;
  height?: number;
}) => {
  return (
    <svg
      className={className}
      style={style}
      width={width}
      height={height}
      viewBox="0 0 10 2"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1 1H9"
        stroke={fill ?? 'black'}
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

